import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';

import Flex from 'components/common/Flex';
import Section from 'components/common/Section';
import LoginCard from 'pages/login/LoginCard';
import LoginBanner from 'pages/login/LoginBanner';

import AppContext from 'config/app-context';

/**
 * Página principal de Login.
 * 
 * Muestra un formulario de acceso y un banner lateral. Ajusta la configuración de la aplicación para habilitar pantalla completa mientras se visualiza.
 *
 * @component
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.leftSideContent - Contenido opcional para mostrar en el banner izquierdo
 * @returns {JSX.Element} Página de Login
 */
const Login = ({ leftSideContent }) => {
    const { config, setConfig } = useContext(AppContext);

    useEffect(() => {
        /**
         * Efecto que activa pantalla completa al entrar
         * y la desactiva al salir de la página de login.
         */
        if (config.isFullscreen !== true) {
            setConfig('isFullscreen', true);
        }

        return () => {
            if (config.isFullscreen !== false) {
                setConfig('isFullscreen', false);
            }
        };
    }, [setConfig, config.isFullscreen]);

    return (
        <Section fluid className="py-0 fullscreen">
            <Row className="g-0 min-vh-100 flex-center">
                <Col lg={8} xxl={8} className="py-3 position-relative">
                    <Card className="overflow-hidden z-index-1">
                        <Card.Body className="p-0">
                            <Row className="h-100 g-0">
                                <Col md={8} className="text-white text-center bg-card-gradient">
                                    <LoginBanner leftSideContent={leftSideContent} />
                                </Col>
                                <Col md={4} as={Flex} alignItems="center" justifyContent="center">
                                    <div className="p-4 p-md-4 flex-grow-1">
                                        <LoginCard />
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Section>
    );
};

Login.propTypes = {
    leftSideContent: PropTypes.node,
    children: PropTypes.node,
    footer: PropTypes.bool
};

export default Login;